enum AllocationFilterSelectedName {
  Employees = 0,
  Clients = 1,
  Projects = 2,
  Positions = 3
}

export default AllocationFilterSelectedName;
